import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalInstance';

msalInstance.addEventCallback(event => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    console.log('Login successful');
    msalInstance.setActiveAccount(event.payload.account);
    // User info is now stored in MSAL - no need to store manually
    const user = {
      userName: event.payload.account.name,
      email: event.payload.account.username
    };
    sessionStorage.setItem("UserInfo", JSON.stringify(user));
  }
  if (event.eventType === EventType.LOGOUT_SUCCESS) {
    sessionStorage.clear();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
